import * as React from "react";
import { useState } from "react";
import { Button, Label } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";

export default observer(function CargaInscripcion() {
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const {
    CargaInscripcionStore: { uploadFile, mensajes },
  } = useStore();

  const changeHandler = (event: React.ChangeEvent<any>) => {
    setSelectedFile(event.currentTarget.files[0]);
  };

    const handleFileUpload = () => {
    uploadFile(selectedFile);
    const div = document.getElementById("cerrar");
    div?.style.setProperty("display", "block");
    //const input = document.getElementById('selectedFile');
  };

  const cerrar = () => {
    const div = document.getElementById("cerrar");
    div?.style.setProperty("display", "none");
    const input = document.getElementById("selectedFile");
    input?.addEventListener("change", setSelectedFile, true);
  };

  return (
    <div id="report">
      <Label with="4" as="label" htmlFor="files" size="big">
        <input
          name="selectedFile"
          id="selectedFile"
          type="file"
          onChange={changeHandler}
        />
      </Label>
      <Button
        id="btn-carga"
        floated="right"
        positive
        size="large"
        style={{ width: "220px", marginRigth: "40px" }}
        onClick={handleFileUpload}
      >
        Cargar Archivo
      </Button>

      <div
        id="cerrar"
        style={{
          backgroundColor: "#E7EDEE",
          width: "100%",
          display: "none",
          flexDirection: "column",
          margin: "25px",
          padding: "20px",
          paddingBottom: "20px",
        }}
      >
        <div
          id="mensaje"
          style={{ fontFamily: "Gotham", fontSize: "16px", flexGrow: 1 }}
          dangerouslySetInnerHTML={{ __html: mensajes }}
        />
        <div style={{ justifyContent: "flex-end" }}>
          <Button
            id="cerrar"
            name="cerrar"
            negative
            size="large"
            floated="right"
            style={{
              marginTop: "25px",
              width: "180px!important",
              marginRigth: "40px!important",
            }}
            onClick={cerrar}
          >
            Cerrar
          </Button>
        </div>
      </div>
    </div>
  );
});
